<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Integration Partner Management'"
    [altColor]="false"
  >
  </aw-divider>

  <div class="table-form-container" [ngClass]="container_theme()">
    <app-aw-date-form
      [title]="'Filter by Date Created'"
      (dateSelected)="onDateSelected($event)"
      [required]="false"
    >
    </app-aw-date-form>
  </div>

  <aw-dialog
    [visible]="openDeleteIntegrationDialog"
    [dialogOptions]="dialogOptionsDelete"
    (primaryAction)="dialogFormDeleteHandler($event)"
    (secondaryAction)="dialogCloseHandler()"
    ariaLabel="Delete integration partner"
  >
  </aw-dialog>
  <aw-table
    [columnsDefinition]="columnsDefinition"
    [tableData]="tableData()"
    [enableStickyOptions]="enableStickyOptions()"
    [sortDisabled]="sortDisabled()"
  >
  </aw-table>
</div>

<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight"> </aw-action-bar>
</div>
